import React from 'react';
import Table from "../../CommonComponents/Table/Table";
import BarChart from "../../CommonComponents/BarChart";
import "../SearchResult.scss";


const TableWrapper = (props) => {
    const loadData = () => {
      if (!props.loader) {
        return props.theadData && props.tbodyData ? (
          <div className="result-page">
            <div className="row">
              {
                props.barChartValues?.length ?
                <div className="col-5 col-lg-5" ref={props.chartRef}>
                  <BarChart barChartDetails={props.barChartDetails} barChartValues={props.barChartValues} chartWidth={props.chartWidth}  />
                </div> : null
              }
              <div className={`col-7 mt-3 ${props.barChartValues?.length? 'col-lg-7 splitcol': 'col-lg-12'}`}>
                <Table theadData={props.theadData} tbodyData={props.tbodyData} />
              </div>
            </div>
            
            {/*20240514 added content check jag*/}
            {props.outputDetails?.sources ? (
              <p className="searchResulttext">
                Source:&nbsp;&nbsp;<p className="textdata">{props.outputDetails?.sources}</p>
              </p>
            ) : null}

            {/*20240514 added content check jag*/}
            {props.outputDetails?.sources ? (
              <p className="searchResulttext">
                Score: &nbsp;&nbsp;<p className="textdata">{props.outputDetails?.score}</p>
              </p>
            ) : null}

            {/* 20240514 shut down for now
            waiting for new api endpont 
            {props.outputDetails?.locationip ? (
              <a href={props.outputDetails?.locationip} target="_blank" rel='noreferrer'>
                <img
                  src={downloadlogo}
                  height="58"
                  width="50"
                  className="downloadImage"
                  alt="json"
                />
              </a>
            ) : null}*/}
          </div>
        ) : null;
      } else {
        return null;
      }
    };
    return <>{!props.message ? loadData() : null}</>;
  };

export default TableWrapper;